export default {"src":"/_next/static/media/big-brain.1b197be1.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};